import { render } from "./HomeLatestBrowsing.vue?vue&type=template&id=3f2094ff&ts=true"
import script from "./HomeLatestBrowsing.vue?vue&type=script&lang=ts"
export * from "./HomeLatestBrowsing.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__